import initGmap from './gmap';

export default ($gMaps = $('.gmap')) => {
  if ($gMaps.length === 0) {
    // bail early if there's no gMap in the body
    return;
  }

  if ('IntersectionObserver' in window) {
    // Check browser support for the IntersectionObserver API
    const intersectionObserver = new IntersectionObserver((entries => {
      let $entries = $();

      $.each(entries, (i, entry) => {
        if (entry.isIntersecting) {
          $entries = $entries.add($(entry.target));
          intersectionObserver.unobserve(entry.target);
        }
      });

      if ($entries.length) {
        initGmap($entries);
      }
    }));

    $gMaps.each((i, e) => intersectionObserver.observe(e));
  } else {
    // fallback to initializing all gMaps within the body
    initGmap($gMaps);
  }
};
